import {useEffect, useState} from "react";
import {AiOutlineEdit, AiOutlinePlusSquare} from "react-icons/ai";
import Popup from "../Components/PopUp";
import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";
import {WeeklyDish} from "../Types/WeeklyDish";
import {getAllWeeklyItems} from "../Services/WeeklyMenuService";
import AddWeeklyItemBody from "./PopUpBodies/AddWeeklyItemBody";
import EditWeeklyItemBody from "./PopUpBodies/EditWeeklyItemBody";
import AddToBasketBody from "./PopUpBodies/AddToBasketBody";
import {Link} from "react-router-dom";

export function ShopView() {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"add" | "edit" | "buy">("add");
  const [selectedDish, setSelectedDish] = useState<WeeklyDish | null>(null);

  const [dishes, setDishes] = useState<WeeklyDish[]>([]);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const loggedIn = Boolean(token);
    setIsLoggedIn(loggedIn);
  }, []);

  useEffect(() => {
    const checkClosed = () => {
      const now = new Date();
      
      // 0 = sun, 1 = mon, 2 = tue, 3 = wed, 4 = thu, 5 = fri, 6 = sat
      const day = now.getDay();
      setIsClosed(day === 5 || day === 6 || day === 0);
    };

    checkClosed();
    const interval = setInterval(checkClosed, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const loadDishes = async () => {
    try {
      const data = await getAllWeeklyItems();
      setDishes(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadDishes();
  }, []);

  const openAddPopup = () => {
    setModalMode("add");
    setSelectedDish(null);
    setIsModalOpen(true);
  };

  const openEditPopup = (dish: WeeklyDish) => {
    setModalMode("edit");
    setSelectedDish(dish);
    setIsModalOpen(true);
  };

  const openBuyPopup = (dish: WeeklyDish) => {
    setModalMode("buy");
    setSelectedDish(dish);
    setIsModalOpen(true);
  };

  const closePopup = () => {
    setSelectedDish(null);
    setIsModalOpen(false);
  };

  const canEdit = isLoggedIn;

  return (
    <>
      <Navbar/>

      <div className="white-text-block white-text-block--header">
        <h1 className="header-1 header-1--centered">Weekmenu</h1>

        {canEdit && (
          <button
            type="button"
            onClick={openAddPopup}>
            <AiOutlinePlusSquare size={50}/>
          </button>
        )}
      </div>

      {isClosed && !canEdit ? (
        <div className="white-text-block white-text-block--center">
          <h1 className="header-1">Gesloten</h1>
          <p>Bestellen voor deze week is niet meer mogelijk.
            Kijk op maandag voor een nieuwe kans!
          </p>
        </div>
      ) : (
        <div className="shop-items-grid">
          {dishes.map((weeklyItem) => (
            <div key={weeklyItem.weekId} className="shop-item">
              <img
                className="picture-container"
                src={`${process.env.REACT_APP_API_URL}${weeklyItem.menuItem.picturePath}`}
                alt={weeklyItem.menuItem.name}/>

              <div className="shop-item-data">
                <h3 className="header-2">{weeklyItem.menuItem.name}</h3>
                <p>{weeklyItem.menuItem.description}</p>
                <hr className="shop-item-divider"/>
                <p> Per stuk: €{weeklyItem.menuItem.price} </p>
                <p> {weeklyItem.dishAmount} stuks beschikbaar </p>
              </div>

              <div className="align-button-right">
                {canEdit && (
                  <button
                    type="button"
                    onClick={() => openEditPopup(weeklyItem)}
                    className="shop-item-button">
                    <AiOutlineEdit size={35}/>
                  </button>
                )}
                {!canEdit && (
                  <button
                    type="button"
                    onClick={() => openBuyPopup(weeklyItem)}
                    className="shop-item-button">
                    <AiOutlinePlusSquare size={35}/>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {!canEdit && (
        <div className="white-text-block white-text-block--center">
          <p>Niet gevonden wat je zocht? Voor speciale verzoeken of grote bestellingen:</p>

          <div className="button-padding">
            <button className="button">
              <Link  to={"/contact"} target="_blank">
                Neem contact op!
              </Link>
            </button>
          </div>

        </div>
      )}

      {canEdit && (
        <Popup isOpen={isModalOpen} onClose={closePopup}>
          {modalMode === "add" ? <AddWeeklyItemBody onSaved={() => {
            loadDishes();
            closePopup();
          }}/> : modalMode === "edit" && selectedDish ? <EditWeeklyItemBody dish={selectedDish} onSaved={() => {
            loadDishes();
            closePopup();
          }}/> : null}
        </Popup>
      )}
      
      {!canEdit && (
        <Popup isOpen={isModalOpen} onClose={closePopup}>
          {modalMode === "buy" && selectedDish ? <AddToBasketBody dish={selectedDish} onSaved={() => {
            loadDishes();
            closePopup();
          }}/> : null}
        </Popup>
      )}
      <ContactFooter/>
    </>
  );
}

export default ShopView;
